import {AcButton, AcDialog} from '@components'
import {LABELS} from '@constants'
import {useStore} from '@hooks/use-store'
import {observer} from 'mobx-react-lite'
import styles from './datagrid-filters.module.scss'

interface IDataGridFilterModalProps {
  filters: React.ReactNode[]
}

export const DatagridFiltersModal = observer(({filters}: IDataGridFilterModalProps) => {
  const {ui} = useStore()

  const handleCancel = () => {
    if (ui.modal && ui.modal.reject) {
      ui.modal.reject()
    }
  }

  return (
    <AcDialog
      title="Filters"
      className={styles['ac-datagrid-filters']}>
      <div className={styles['ac-datagrid-filters-content']}>
        {filters.map((filter, index) => (
          <div key={index} className={styles['ac-datagrid-filters-item']}>
            {filter}
          </div>
        ))}
      </div>
      <div className={styles['ac-datagrid-filters-actions']}>
        <AcButton
          color="secondary"
          label={LABELS.CLOSE}
          onClick={handleCancel}
        />
      </div>
    </AcDialog>
  )
})
